import React, { useEffect, useState } from 'react'
import { useAuth } from '../AuthContext'
import { API_BASE } from '../config'

const FONT = "'DM Sans',sans-serif"

// "Refer a friend" card. Renders nothing unless the referral program is enabled
// (REFERRALS_ENABLED=1 on the server), so it stays invisible until launch.
// Honest framing: free skin check + real dermatologist — never "accurate AI".
export default function ReferAndEarn() {
  const { fetchWithAuth, user } = useAuth()
  const [data, setData] = useState(null)
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!user?.token) return
    fetchWithAuth(`${API_BASE}/api/referral/me`).then(r => r.json())
      .then(d => { if (d && d.enabled && d.code) setData(d) }).catch(() => {})
  }, [user?.token]) // eslint-disable-line

  if (!data?.code) return null

  const pct = data.percentOff || 10
  const message = `Get a free skin check with a real dermatologist at Revive — and we both get ${pct}% off the shop when you book a consult. ${data.link}`
  const share = async () => {
    try {
      if (navigator.share) { await navigator.share({ title: 'Revive', text: message }); return }
    } catch {}
    try { await navigator.clipboard.writeText(message); setCopied(true); setTimeout(() => setCopied(false), 2000) } catch {}
  }

  return (
    <div style={{ background: 'linear-gradient(150deg,#0F3D24,#2E8B4F)', borderRadius: 18, padding: '1.1rem 1.2rem', color: '#fff', margin: '0 0 12px', fontFamily: FONT, boxShadow: '0 8px 24px rgba(15,61,36,.25)' }}>
      <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: 4 }}>🎁 Refer a friend</div>
      <div style={{ fontSize: '.8rem', color: 'rgba(255,255,255,.85)', lineHeight: 1.5, marginBottom: 12 }}>
        Give a friend a free skin check with a real dermatologist. When they book a consult, <b>you both get {pct}% off</b> the shop.
      </div>
      <button onClick={share} style={{ width: '100%', background: '#fff', color: '#0F3D24', border: 'none', borderRadius: 12, padding: '.7rem', fontWeight: 800, fontSize: '.85rem', cursor: 'pointer', fontFamily: FONT }}>
        {copied ? '✓ Link copied' : '📣 Share your invite link'}
      </button>
      {(data.invited > 0 || data.qualified > 0) && (
        <div style={{ fontSize: '.68rem', color: 'rgba(255,255,255,.7)', marginTop: 8, textAlign: 'center' }}>
          {data.qualified} joined · {data.invited} invited
        </div>
      )}
    </div>
  )
}
